import { useContext as e } from "react";
import { LanguageResolverContext as o } from "./language.js";
import "./languageResolver.js";
const n = () => e(o);
export {
  n as useLanguageResolver
};
//# sourceMappingURL=useLanguageResolver.js.map
